import { Select, message } from 'antd'
import AddTeacherModal from 'app/gomsacademy/components/AddTeacherModal'
import { useGetUserClass } from 'app/gomsacademy/hooks/GetClassList'
import { useGetSubject } from 'app/gomsacademy/hooks/GetSubjectList'
import { useGetUser } from 'app/gomsacademy/hooks/GetUser'
import { useTeacherStudent } from 'app/gomsacademy/hooks/TeacherStudentList'
import { useToken } from 'app/hooks'
import React, { useEffect, useState } from 'react'
import { BsFillPencilFill } from 'react-icons/bs'
import { FaCheck } from 'react-icons/fa6'
import API from 'utils/api'
import { convertBinaryToDays } from 'utils/ciutils'
import { Icon } from '../Home/styles'
import {
	FixBtns,
	LectureListDisplay,
	LectureTotal,
	LectureView,
	LectureViewHeader,
	LectureWrapper,
	StudentViewTable,
} from '../Lecture/styles'
import TeacherList from './TeacherList'
import TeacherTotalTable from './TeacherTotalTable'

export const Teacher = ({ isWrite, setIsWrite, setLectureSt, setSelectLecture }) => {
	const { data: token } = useToken()
	const { TeacherStudentData: DirectorList, mutate: DirectorMutate } = useTeacherStudent(1)
	const { mutate: TeacherMutate } = useTeacherStudent(2)
	const { TeacherStudentData: DepartmentManager, mutate: DepartmentManagerMutate } =
		useTeacherStudent(4)
	const { SubjectList } = useGetSubject()
	const [selectTeacher, setSelectTeacher] = useState()
	const { UserData, mutate: userDataMutate } = useGetUser(selectTeacher)
	const { UserClassData } = useGetUserClass(selectTeacher)
	const [isTotal, setIsTotal] = useState(true)
	const [isAddTeacher, setIsAddTeacher] = useState(false)
	const [isFix, setIsFix] = useState(false)
	const [selectEmployee, setSelectEmployee] = useState('전체')
	console.log(UserData)

	// Track which category the selected user was clicked from (front-only policy)
	const [selectedEmployeeKind, setSelectedEmployeeKind] = useState<'원장' | '실장' | '강사' | null>(null)
	const isSubjectEditable = selectedEmployeeKind === '강사'

	const [fixName, setFixName] = useState(UserData?.name || '')
	const [fixEmail, setFixEmail] = useState(UserData?.email || '')
	const [fixPhone, setFixPhone] = useState(UserData?.phone || '')
	const [fixCreatedAt, setFixCreatedAt] = useState(UserData?.createdAt || '')
	const [fixMemo, setFixMemo] = useState(UserData?.memo || '')
	const [fixSubjectIds, setFixSubjectIds] = useState<number[]>([])

	const mapSubjectNamesToIds = (subjectNames: any): number[] => {
		const names: string[] = Array.isArray(subjectNames)
			? subjectNames
			: typeof subjectNames === 'string' && subjectNames.length
				? [subjectNames]
				: []

		const idSet = new Set<number>()
		names.forEach(n => {
			const found = SubjectList?.find(s => s?.name === n)
			if (found?.id && !Number.isNaN(Number(found.id))) idSet.add(Number(found.id))
		})
		return Array.from(idSet)
	}

	const sameNumberSet = (a: number[], b: number[]) => {
		if (a.length !== b.length) return false
		const as = new Set(a)
		for (const x of b) if (!as.has(x)) return false
		return true
	}

	const symmetricDifference = (a: number[], b: number[]) => {
		const as = new Set(a)
		const bs = new Set(b)
		const out: number[] = []
		for (const x of as) if (!bs.has(x)) out.push(x)
		for (const x of bs) if (!as.has(x)) out.push(x)
		return out
	}

	// Keep editable fields in sync when switching teachers / when data loads.
	useEffect(() => {
		if (!UserData) return
		setFixName(UserData?.name || '')
		setFixEmail(UserData?.email || '')
		setFixPhone(UserData?.phone || '')
		setFixCreatedAt(UserData?.createdAt || '')
		setFixMemo(UserData?.memo || '')
		// subjectIds are not returned here consistently; derive from subjectNames + SubjectList.
	}, [UserData?.id])

	useEffect(() => {
		if (!UserData) return
		setFixSubjectIds(mapSubjectNamesToIds(UserData?.subjectNames))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [UserData?.id, SubjectList])

	const handleWriteClick = index => {
		setIsWrite(prevStates => {
			const newStates = [...prevStates]
			newStates[index] = !newStates[index]
			return newStates
		})
	}

	const DeleteTeacher = (userId, userName) => {
		const shouldDelete = window.confirm(`정말로 '${userName}' 강사를 삭제하시겠습니까?`)

		if (shouldDelete) {
			API.delete('/users/' + userId, token + '', {})
				.then((res: any) => {
					if (res.result.success) {
						message.success('삭제되었습니다')
						TeacherMutate()
						setIsTotal(true)
					} else {
						if (res?.result?.message?.includes('foreign key')) {
							message.error('연결된 데이터가 있어 삭제할 수 없습니다.')
						} else {
							message.error(res?.result?.message || '삭제에 실패했습니다.')
						}
					}
				})
				.catch((err: any) => {})
		}
	}
	const SaveTeacher = userId => {
		// Only send changed keys to avoid overwriting existing data with empty defaults.
		const datas: any = {}
		if (!UserData) return

		if ((UserData?.name || '') !== fixName) datas.name = fixName
		if ((UserData?.phone || '') !== fixPhone) datas.phone = fixPhone
		if ((UserData?.createdAt || '') !== fixCreatedAt) datas.createdAt = fixCreatedAt
		if ((UserData?.email || '') !== fixEmail) datas.email = fixEmail
		if ((UserData?.memo || '') !== fixMemo) datas.memo = fixMemo

		// subjectIds: we use backend "set" mode to make the teacher's active subjects exactly match this list.
		const currentSubjectIds = mapSubjectNamesToIds(UserData?.subjectNames)
		const nextSubjectIds = Array.from(new Set((fixSubjectIds || []).map(Number).filter(n => n > 0)))
		if (isSubjectEditable && !sameNumberSet(currentSubjectIds, nextSubjectIds)) {
			datas.subjectIds = nextSubjectIds
		}

		if (Object.keys(datas).length < 1) {
			message.info('수정사항이 없습니다')
			setIsFix(false)
			return
		}

		API.put('/users/' + userId, token + '', {
			datas,
		})
			.then((res: any) => {
				if (res.result.success) {
					message.success('수정되었습니다')
					userDataMutate()
					setIsFix(false)
				}
			})
			.catch((err: any) => {})
	}

	const handleClickOutsideSelect = (event: any) => {
		const target = event?.target as HTMLElement | null
		if (!target) return

		// keep edit mode when clicking inside the teacher detail area
		if (target.closest('.selectTeacher')) return

		// antd Select dropdown is rendered in a portal (outside .selectTeacher)
		// so we must treat clicks on it as "inside"
		if (target.closest('.ant-select')) return
		if (target.closest('.ant-select-dropdown')) return

		setIsFix(false)
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutsideSelect)
		return () => {
			document.removeEventListener('mousedown', handleClickOutsideSelect)
		}
	}, [])

	return (
		<LectureWrapper>
			<TeacherList
				setIsAddTeacher={setIsAddTeacher}
				setIsTotal={setIsTotal}
				selectTeacher={selectTeacher}
				setSelectTeacher={setSelectTeacher}
				selectEmployee={selectEmployee}
				setSelectEmployee={setSelectEmployee}
				setSelectedEmployeeKind={setSelectedEmployeeKind}
			/>
			<LectureView>
				{isTotal && (
					<TeacherTotalTable
						setIsTotal={setIsTotal}
						setSelectTeacher={setSelectTeacher}
						selectEmployee={selectEmployee}
						setSelectedEmployeeKind={setSelectedEmployeeKind}
					/>
				)}
				{isTotal == false && selectTeacher && (
					<div className="selectTeacher">
						<LectureViewHeader>
							<p>
								{!isFix ? (
									UserData?.name
								) : (
									<input
										className="fixName"
										type="text"
										placeholder={UserData?.name}
										onChange={e => setFixName(e.target.value)}
									/>
								)}
							</p>
							<FixBtns>
								{!isFix ? (
									<>
										<button className="fix" onClick={() => setIsFix(true)}>
											수정
										</button>
										<button
											className="delete"
											onClick={() => DeleteTeacher(UserData?.id, UserData?.name)}>
											삭제
										</button>
									</>
								) : (
									<>
										<button className="fix" onClick={() => SaveTeacher(UserData?.id)}>
											저장
										</button>
										<button className="delete" onClick={() => setIsFix(false)}>
											취소
										</button>
									</>
								)}
							</FixBtns>
						</LectureViewHeader>
						<StudentViewTable className="teacherTbody">
							<thead>
								<tr>
									<th>과목</th>
									<th>아이디</th>
									<th>휴대폰번호</th>
									<th>수업과정</th>
									<th>등록일</th>
									<th>비고</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{!isFix ? (
											Array.isArray(UserData?.subjectNames)
												? UserData?.subjectNames.join(', ')
												: UserData?.subjectNames
										) : (
											!isSubjectEditable ? (
												// Policy: hide subject edit for 원장/실장
												Array.isArray(UserData?.subjectNames)
													? UserData?.subjectNames.join(', ')
													: UserData?.subjectNames
											) : (
												<Select
													mode="multiple"
													placeholder="과목선택"
													value={fixSubjectIds}
													style={{ minWidth: 160 }}
													options={(SubjectList || []).map(it => ({
														label: it?.name,
														value: Number(it?.id),
													}))}
													onChange={vals => setFixSubjectIds((vals as number[]).map(Number))}
												/>
											)
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.email
										) : (
											<input
												type="text"
												placeholder={UserData?.email}
												onChange={e => setFixEmail(e.target.value)}
											/>
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.phone
										) : (
											<input
												type="text"
												placeholder={UserData?.phone}
												onChange={e => setFixPhone(e.target.value)}
											/>
										)}
									</td>
									<td>{UserData?.classCount} 과정</td>
									<td>
										{!isFix ? (
											UserData?.createdAt
										) : (
											<input type="date" onChange={e => setFixCreatedAt(e.target.value)} />
										)}
									</td>
									<td>
										{!isFix ? (
											UserData?.memo == '' ? (
												'-'
											) : (
												UserData?.memo
											)
										) : (
											<input
												type="text"
												placeholder={UserData?.memo}
												onChange={e => setFixMemo(e.target.value)}
											/>
										)}
									</td>
								</tr>
							</tbody>
						</StudentViewTable>
						{/* ===== 모바일 일 때 ===== */}
						<LectureListDisplay className="teacherMobile">
							<div className="mobileTable">
								<div className="tableRow">
									<div className="tableEl">
										<p className="th">과목</p>
										<p className="td">{UserData?.subjectNames}</p>
									</div>
									<div className="tableEl">
										<p className="th">권한</p>
										<p className="td">{UserData?.authority}</p>
									</div>
								</div>
								<div className="tableRow">
									<div className="tableEl">
										<p className="th">수업과정</p>
										<p className="td">{UserData?.classCount} 과정</p>
									</div>
									<div className="tableEl">
										<p className="th">등록일</p>
										<p className="td">{UserData?.createdAt}</p>
									</div>
								</div>
								<div className="tableRow">
									<p className="th">아이디</p>
									<p className="td">{UserData?.email}</p>
								</div>
								<div className="tableRow">
									<p className="th">휴대폰번호</p>
									<p className="td">{UserData?.phone}</p>
								</div>
								<div className="tableRow">
									<p className="th">비고</p>
									<p className="td">{UserData?.memo == '' ? '-' : UserData?.memo}</p>
								</div>
							</div>
						</LectureListDisplay>
						<StudentViewTable>
							<tbody className="teacherTbody">
								<tr>
									<th className="no">No.</th>
									<th>강의</th>
									<th className="school">학교</th>
									<th>요일</th>
									<th>시간</th>
									<th>방식</th>
									<th>개강일</th>
									<th>종강일</th>
								</tr>
								{UserClassData?.map((it, idx) => (
									<tr key={idx}>
										<td className="no">{idx + 1}</td>
										<td className="lecture">
											{it.name}
											{it.type == '강의식' && (
												<button
													className="manageNoteBtn"
													onClick={() => {
														handleWriteClick(idx)
														setSelectLecture(it)
														setLectureSt(true)
													}}
													style={{
														border: '1px solid #EFA44F',
														backgroundColor: isWrite[idx] ? '#EFA44F' : 'transparent',
														color: isWrite[idx] ? '#FFF' : '#EFA44F',
													}}>
													<Icon>{isWrite[idx] ? <FaCheck /> : <BsFillPencilFill />}</Icon>
													<p style={{ fontSize: '14px' }}>학습일지</p>
												</button>
											)}
										</td>
										<td className="school">{it.schoolType}</td>
										<td>{convertBinaryToDays(it.days)}</td>
										<td>
											{it.time == '' || it.time == '00:00'
												? '-'
												: it?.time?.slice(3, 5) === '00'
												  ? it?.time?.slice(0, 2) + '시간'
												  : it?.time?.slice(0, 2) + '시간' + it?.time?.slice(3, 5) + '분'}
										</td>
										<td>{it.type}</td>
										<td>{it?.startedAt?.slice(0, 10)}</td>
										<td className="">{it.endedAt == '' ? '-' : it?.endedAt?.slice(0, 10)}</td>
									</tr>
								))}
							</tbody>
						</StudentViewTable>
						<div className="teacherMobile">
							{UserClassData?.map((it, idx) => (
								<LectureListDisplay>
									<LectureTotal style={{}}>
										<p>{it.lecture}</p>
										{it.type == '강의식' && (
											<button
												className="manageNoteBtn"
												onClick={() => {
													handleWriteClick(idx)
													setSelectLecture(it)
													setLectureSt(true)
												}}
												style={{
													border: '1px solid #EFA44F',
													backgroundColor: isWrite[idx] ? '#EFA44F' : '#fff',
													display: 'flex',
													alignItems: 'center',
													borderRadius: '4px',
													padding: '5px 8px',
												}}>
												<p style={{ fontSize: '14px', color: isWrite[idx] ? '#FFF' : '#EFA44F' }}>
													학습일지
												</p>
											</button>
										)}
									</LectureTotal>
									<div className="mobileTable">
										<div className="tableRow">
											<div className="tableEl">
												<p className="th">학교</p>
												<p className="td">{it.schoolType}</p>
											</div>
											<div className="tableEl">
												<p className="th">요일</p>
												<p className="td">{convertBinaryToDays(it.days)}</p>
											</div>
										</div>
										<div className="tableRow">
											<div className="tableEl">
												<p className="th">방식</p>
												<p className="td">{it.type}</p>
											</div>
											<div className="tableEl">
												<p className="th">시간</p>
												<p className="td">{it.time}</p>
											</div>
										</div>
										<div className="tableRow">
											<div className="tableEl">
												<p className="th">개강일</p>
												<p className="td">{it?.startedAt?.slice(0, 10)}</p>
											</div>
											<div className="tableEl">
												<p className="th">종강일</p>
												<p className="td">{it.endedAt == '' ? '-' : it?.endedAt?.slice(0, 10)}</p>
											</div>
										</div>
									</div>
								</LectureListDisplay>
							))}
						</div>
					</div>
				)}
			</LectureView>
			{isAddTeacher && <AddTeacherModal setIsAddTeacher={setIsAddTeacher} />}
		</LectureWrapper>
	)
}

export default React.memo(Teacher)
